/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { FormDefinitionDraftCategoryStats } from "./FormDefinitionDraftCategoryStats";
// @ts-ignore
import { FormDefinitionSummaryExtended } from "./FormDefinitionSummaryExtended";
// @ts-ignore
import { QuestionDefinitionSummary } from "./QuestionDefinitionSummary";
// @ts-ignore
import { Standard } from "./Standard";

/**
 * 
 * @export
 * @interface FormDefinitionSummaryDraftExtended
 */
export interface FormDefinitionSummaryDraftExtended {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    created_at: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    updated_at: Date;
    /**
     * Status for form definition initialization (creation).
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    creation_status: FormDefinitionSummaryDraftExtendedCreationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    owner_id: string;
    /**
     * ID of my own preview form (if available)
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    preview_form_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    standard_id: string;
    /**
     * 
     * @type {number}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    with_condition_count: number;
    /**
     * 
     * @type {Array<FormDefinitionDraftCategoryStats>}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    categories?: Array<FormDefinitionDraftCategoryStats>;
    /**
     * 
     * @type {Array<QuestionDefinitionSummary>}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    questions?: Array<QuestionDefinitionSummary>;
    /**
     * 
     * @type {Standard}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    standard: Standard;
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionSummaryDraftExtended
     */
    next_event_token: string;
}




/**
* @export
* @enum {string}
*/
export enum FormDefinitionSummaryDraftExtendedCreationStatusEnum {
    FINISHEDFAIL = 'FINISHED_FAIL',
    FINISHEDSUCCESS = 'FINISHED_SUCCESS',
    INPROGRESS = 'IN_PROGRESS',
    INQUEUE = 'IN_QUEUE'
}


